module.exports = __webpack_public_path__ + "static/media/6.c80394c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/6.jpg
// module id = 28
// module chunks = 0